export default __webpack_public_path__ + "static/media/HUD-Effects-04.5a764b26.jpg";